import Nullstack from 'nullstack';
export default function IconSteeringWheelOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-steering-wheel-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20.04 16.048a9 9 0 0 0 -12.083 -12.09m-2.32 1.678a9 9 0 1 0 12.737 12.719"
  }), "   ", Nullstack.element("path", {
    d: "M10.595 10.576a2 2 0 1 0 2.827 2.83"
  }), "   ", Nullstack.element("path", {
    d: "M12 14v7"
  }), "   ", Nullstack.element("path", {
    d: "M10 12l-6.75 -2"
  }), "   ", Nullstack.element("path", {
    d: "M15.542 11.543l5.208 -1.543"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}